
import Vue from 'vue';
import { VFairPavilionGroup } from '~/services/VFairService';

// Components
import PavilionButton from './PavilionButton.vue';

const component = Vue.extend({
    name: 'PavilionGroup',
    components: {
        PavilionButton,
    },
    props: {
        vFairID: {
            type: String,
            required: true,
        },
        pavilionGroup: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            pavilions: [] as VFairPavilionGroup[],
        };
    },
    methods: {
        gotoPavilion(pavilionId: string) {
            this.$emit('openPavilion', pavilionId);
        },
    },
    mounted() {
        this.pavilions = this.pavilionGroup.pavilions;
    },
});

export default component;
